import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "warehouse-importer-add-edit-modal",
    attrs: {
      "width": 1000,
      "title": _vm.t('新增协议')
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "logistic_ticket_add_edit_form",
      "model": _vm.formData,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 20
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u534F\u8BAE"),
      "prop": "doc_type",
      "label": _vm.t('协议')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "allow-clear": "",
      "placeholder": _vm.tc('请选择协议')
    },
    model: {
      value: _vm.formData.doc_type,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "doc_type", $$v);
      },
      expression: "formData.doc_type"
    }
  }, _vm._l(_vm.protocolTypeList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.doc_type
      }
    }, [_vm._v(_vm._s(item.doc_type_text) + _vm._s(item.doc_version))]);
  }), 1)], 1)], 1), _c('div', {
    staticClass: "ct",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-permission": "logistic_ticket_modal_save",
      "id": "logistic_ticket_modal_save",
      "data-sign": "logistic_ticket_add_edit_save",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "type": "primary",
      "data-permission": "logistic_ticket_modal_submit",
      "id": "logistic_ticket_modal_submit",
      "data-sign": "logistic_ticket_add_edit_submit",
      "fbu-analyse-name": $t("\u53BB\u7B7E\u7F72")
    },
    on: {
      "click": function ($event) {
        return _vm.handleOk();
      }
    }
  }, [_vm._v(_vm._s(_vm.t('去签署')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };